import { NgModule } from '@angular/core';
import { QuestionModule } from '../abstract/question.module';
import { QuestionTextComponent } from './question-text.component';

@NgModule({
  imports: [
    QuestionModule,
  ],
  declarations:[QuestionTextComponent],
  exports:[QuestionTextComponent],
})
export class QuestionTextModule { }

